import clsx from 'clsx';
import React from 'react';

import { LoadingPanel } from '../Loading';
import { Layout } from './Layout';

/**
 * Page main landmark
 */
export function PageMain({
    ref,
    ...props
}: ({
    children: React.ReactNode;
    suspense?: boolean;
    wide?: boolean;
} & React.ComponentProps<'main'>) & { ref?: React.Ref<HTMLElement> }) {
    const { suspense = true, wide = false, className, ...rest } = props;

    const main = (
        <main
            ref={ref}
            {...rest}
            className={clsx(
                '@container/page flex w-full flex-col gap-10 pt-6 pb-10 md:pt-10 md:pb-16',
                className
            )}
        />
    );
    return (
        <Layout wide={wide}>
            {suspense ? (
                <React.Suspense fallback={<LoadingPanel size="large" />}>{main}</React.Suspense>
            ) : (
                main
            )}
        </Layout>
    );
}
